import { Component, Input, OnInit } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';
import { Observable } from 'rxjs';
import { map, withLatestFrom } from 'rxjs/operators';

import { FinnairCart, TranslatedBenefitRow } from '@fcom/dapi/api/models';
import { UpgradeOfferState } from '@fcom/common-booking';
import { Amount } from '@fcom/dapi';
import { shouldDisplayBenefit } from '@fcom/common-booking/utils/benefit.utils';

interface Prices {
  outboundPrice: Amount;
  outboundUpgradePrice: Amount;
  inboundPrice: Amount;
  inboundUpgradePrice: Amount;
  currentPrice: Amount;
  newPrice: Amount;
}

@Component({
  selector: 'fin-upgrade-promotion-modal',
  templateUrl: './upgrade-promotion-modal.component.html',
  styleUrls: ['upgrade-promotion-modal.component.scss'],
  standalone: false,
})
export class UpgradePromotionModalComponent implements OnInit {
  readonly SvgLibraryIcon = SvgLibraryIcon;

  @Input() cart$: Observable<FinnairCart>;
  @Input() upgradeOffer$: Observable<UpgradeOfferState>;

  currencyCode$: Observable<string>;

  prices$: Observable<Prices>;
  currentBenefits$: Observable<TranslatedBenefitRow[]>;
  newBenefits$: Observable<TranslatedBenefitRow[]>;

  ngOnInit(): void {
    this.currencyCode$ = this.cart$.pipe(map((cart) => cart.prices?.unpaid?.total?.total.totalAmount.currencyCode));
    this.prices$ = this.upgradeOffer$.pipe(
      withLatestFrom(this.currencyCode$),
      map(([offer, currencyCode]) => {
        const currentPrice = [offer.inboundPrice, offer.outboundPrice].reduce((acc, priceStr) => {
          if (priceStr) {
            return acc + parseFloat(priceStr);
          }
          return 0;
        }, 0);
        return {
          outboundPrice: this.strToAmount(offer.outboundPrice, currencyCode),
          outboundUpgradePrice: this.strToAmount(offer.outboundUpgradePrice, currencyCode),
          inboundPrice: this.strToAmount(offer.inboundPrice, currencyCode),
          inboundUpgradePrice: this.strToAmount(offer.inboundUpgradePrice, currencyCode),
          currentPrice: this.strToAmount(String(currentPrice), currencyCode),
          newPrice: this.strToAmount(String(offer.totalUpgradePrice), currencyCode),
        };
      })
    );

    this.currentBenefits$ = this.upgradeOffer$.pipe(
      map((offer) => offer.currentFareFamily.translatedBenefitRows.filter((benefit) => shouldDisplayBenefit(benefit)))
    );
    this.newBenefits$ = this.upgradeOffer$.pipe(
      map((offer) => offer.upgradeFareFamily.translatedBenefitRows.filter((benefit) => shouldDisplayBenefit(benefit)))
    );
  }

  private strToAmount(price: string, currencyCode: string): Amount | undefined {
    if (!price) {
      return undefined;
    }
    return {
      currencyCode: currencyCode,
      amount: price,
    };
  }
}
